module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAmElEQVRYR+2UwRGEMAwDpQKo5hqAlmgArgnagRpogxlaEJP/wXnww37YbyuRN4qJ4GLw/SgDRaAI5CYgqQcwAuhe7osDwEJyu9M/EpC0AmgmPLWRHN4aiCXgGduqzR3CNoWkjyOEJ8n9ica/EM4AJivOm74vyXbOz8ptIPwJnOhN8ty/oFZxOAFTipxNuUPoHM4kLwJFoAhcGYE2IVm/Q3wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-mobile.png
// module id = gBdf
// module chunks = 1